import { useEffect, useRef, useState, type RefObject } from "react";
import { postPresence } from "./api";
import { PresenceMonitor } from "./presence";

export function usePresence(videoRef: RefObject<HTMLVideoElement | null>, sessionId: string, viewerId: string, enabled: boolean, playbackAllowed: boolean, channel: number, externalPlayback: boolean | null = null) {
  const [count, setCount] = useState<number | null>(null);
  const [station, setStation] = useState<{ count: number | null; channel: number | null }>({ count: null, channel: null });
  const sequence = useRef(0);
  const monitor = useRef<PresenceMonitor | null>(null);
  useEffect(() => {
    if (!videoRef.current) return;
    const observer = new PresenceMonitor({
      video: videoRef.current, visibility: document, lifecycle: window,
      sessionId, viewerId, sequence, enabled: false,
      send: postPresence, publish: setCount, publishStation: (count, channel) => setStation({ count, channel })
    });
    monitor.current = observer;
    observer.start();
    return () => { observer.stop(); monitor.current = null; };
  }, [videoRef, sessionId, viewerId]);
  useEffect(() => { monitor.current?.setEnabled(enabled, playbackAllowed, channel, externalPlayback); }, [enabled, playbackAllowed, channel, externalPlayback, sessionId, viewerId]);
  return { total: count, station: station.channel === channel ? station.count : null };
}
